var hashQueryString = window.location.hash,
  loadMore = $('.silk-loadmore'),
  language = loadMore.data('language'),
  search = loadMore.data('search');
if (hashQueryString != '' && hashQueryString.indexOf('=') !== -1) {
  if (hashQueryString.slice(0, 14) != '#systemfilter-') {
    $('.silk-product-item-holder').html('');
    $('.silk-group-product-holder').remove();
    silkProductLoad(1);
  }
}
$('.silk-loadmore').click(function () {
  var currentPage = $(this).data('currentpage');
  var nextPage = currentPage + 1;
  silkProductLoad(nextPage);
  $(this).data('currentpage', nextPage);
});
$('.silk-hash-clear').click(function () {
  history.pushState('', document.title, window.location.pathname + window.location.search);
  $('#silkFilterForm').trigger('reset');
  $('.silk-dropdown-filter').find('option').attr('selected', false);
  silkProductLoad(1);
});
$('.silk-dropdown-filter').on('change', function () {
  var inputValue = $(this).val();
  $(this).val(inputValue).find('option[value="' + inputValue + '"]').attr('selected', true);
  silkHashFilter();
});
$('.silk-hash-filter').on('click', function () {
  silkHashFilter();
});
function silkHashFilter() {
  var objectFilter = new Object();

  // This will look for radio and checkbox input type that has silk-hash-filter class
  $('.silk-hash-filter').each(function () {
    var inputName = $(this).attr('name');
    var inputValue = $(this).val();
    if ($(this).prop('checked') == true) {
      objectFilter[inputName + 'List'] += ',' + inputValue;
    }
  });

  // This will look for all select input type that has silk-dropdown-filter class
  $('.silk-dropdown-filter').each(function () {
    var inputName = $(this).attr('name');
    var inputValue = $(this).find('option:selected').val();
    objectFilter[inputName + 'List'] += ',' + inputValue;
  });
  var filterUrl = '';
  $.each(objectFilter, function (filterKey, filterValue) {
    filterUrl += filterKey.replace('List', '') + '=' + filterValue.replace('undefined,', '') + '&';
  });

  // If no category selected use current category
  var currentCategory = $('.silk-loadmore').data('currentcategory');
  if (!objectFilter.hasOwnProperty('categoryList') && currentCategory != '') {
    filterUrl += 'category=' + currentCategory + '&';
  }

  // Remove excess & character at the end of query
  filterUrl = filterUrl.substr(0, filterUrl.length - 1);
  filterUrl = '#' + filterUrl;
  window.history.pushState('', 'Title', filterUrl);
  silkProductLoad(1);

  // Reset Current Page Count upon Filter update
  $('.silk-loadmore').data('currentpage', 1);
}
function silkProductLoad(nextPage) {
  // this will set selected filter
  silkSetFilterUsingHash();
  var ajaxUrl = $('#silkFilterForm').data('ajaxurl');
  if (typeof ajaxUrl === 'undefined' || !ajaxUrl) {
    ajaxUrl = $('.silk-loadmore').data('ajaxurl');
  }
  var currentCategory = $('.silk-loadmore').data('currentcategory');
  var currentTermId = $('.silk-loadmore').data('currentterm_id');
  var hashQueryString = window.location.hash;
  hashQueryString = hashQueryString.replace('#', '&');
  if (hashQueryString != '') {
    ajaxUrl = ajaxUrl + hashQueryString + '&termid=' + currentTermId;
  } else {
    ajaxUrl = ajaxUrl + '&category=' + currentCategory + '&termid=' + currentTermId;
  }
  if (search) {
    ajaxUrl += '&search=' + encodeURIComponent(search);
  }
  if (language) {
    ajaxUrl += '&lang=' + language;
  }
  console.log(ajaxUrl);
  console.log(ajaxUrl + '&page=' + nextPage);
  $.ajax({
    url: ajaxUrl + '&page=' + nextPage,
    type: 'GET',
    beforeSend: function beforeSend() {
      $('.silk-loadmore').addClass('d-none');
      $('.silk-spinner').removeClass('d-none');
      $('.silk-product-item-holder').parents('section').removeClass('d-none');
    },
    error: function error(data, textStatus) {
      console.log(data);
      console.log(textStatus);
    },
    success: function success(data, textStatus, jqXHR) {
      if (data) {
        $('.silk-loadmore').removeClass('d-none');
        $('.silk-spinner').addClass('d-none');

        // Need to clear list if Filter is trigger
        if (nextPage == 1) {
          $('.silk-product-item-holder').html('');
          $('.silk-group-product-holder').remove();
        }
        if ($(data).length > 0) {
          //var count = 1;
          $(data).each(function (key, val) {
            $('.silk-product-item-holder').append(val.product_item);
            //count++;
          });
          if (window.lazyLoadInstance) {
            window.lazyLoadInstance.update();
          }

          // Show Product Bg
          if ($('.bg-image').hasClass('d-none')) {
            $('.bg-image').removeClass('d-none');
          }
        }
        var totalCount = parseInt(jqXHR.getResponseHeader('X-WP-Total'), 10);
        if ($('.js-total-count')) {
          $('.js-total-count').text(totalCount);
        }
        if (totalCount === 0) {
          $('.silk-loadmore').addClass('d-none');
        }
        var totalPage = parseInt(jqXHR.getResponseHeader('X-WP-TotalPages'), 10);
        if ($('.silk-loadmore').data('currentpage') == totalPage || data.length == 0) $('.silk-loadmore').addClass('d-none'); // if last page, remove the button
      } else {
        $('.silk-loadmore').addClass('d-none'); // if no data, remove the button as well
      }
    }
  });
}
function silkSetFilterUsingHash() {
  var hash = window.location.hash;
  hash = hash.replace('#', '');
  var hashArr = hash.split('&');
  if (hashArr.length > 0) {
    $(hashArr).each(function (key, queryItem) {
      var queryItemArr = queryItem.split('=');
      if (queryItemArr.length > 0) {
        $(queryItemArr).each(function (queryItemKey, queryItemValue) {
          var queryItemValueArr = queryItemValue.split(',');
          if (queryItemValueArr.length > 0) {
            $(queryItemValueArr).each(function (queryItemSelectedKey, queryItemSelectedValue) {
              if (queryItemSelectedValue != '') {
                var inputName = queryItemArr[0];
                if ($('input[name="' + inputName + '"]').hasClass('silk-hash-filter')) {
                  $('input[name="' + inputName + '"]:checkbox[value="' + queryItemSelectedValue + '"]').prop('checked', 'true');
                } else {
                  $('select[name="' + inputName + '"]').val(queryItemSelectedValue).find('option[value="' + queryItemSelectedValue + '"]').attr('selected', true);
                }
              }
            });
          }
        });
      }
    });
  }
}


// WEBPACK FOOTER //
// ./scripts/components/category.js